function hasTags(entry, tags) {
	entry.tagGroups?.forEach(g => {
		g.tags?.forEach(t => {
			tags = tags.filter(s => s !== t.slug);
		});
	});

	entry.profiles?.forEach(p => {
		p.tagGroups?.forEach(g => {
			g.tags?.forEach(t => {
				tags = tags.filter(s => s !== t.slug);
			});
		});
	});

	return tags.length <= 0;
}

function applyFilters(targets, filters) {
	let filteredTargets = targets;

	const slugFilter = filters?.slugs || [];
	if (slugFilter.length > 0) {
		filteredTargets = filteredTargets.filter(r => slugFilter.includes(r.entrySlug));
	}

	const typeFilter = filters?.types || [];
	if (typeFilter.length > 0) {
		filteredTargets = filteredTargets.filter(r => typeFilter.includes(r.type));
	}

	const tagFilter = filters?.tags || [];
	if (tagFilter.length > 0) {
		filteredTargets = filteredTargets.filter(r => hasTags(r.listEntry, tagFilter));
	}

	return filteredTargets;
}

const TLAOK_TARGETS = {
	"REGIMENTS": (list, origin, params) => {
		let regiments = list.children;
		if (params?.filters) {
			regiments = applyFilters(regiments, params.filters)
		}
		const children = [];
		regiments.forEach(r => {
			if (r.children) children.push(...r.children);
		});
		regiments.push(...children);
		return regiments;
	},
	"PARENT": (list, origin) => {
		return [origin.parent];
	},
	"SELF": (list, origin) => {
		return [origin];
	},
	"REGIMENT": (list, origin) => {
		return [origin, ...origin.children];
	},
	"CHILDREN": (list, origin) => {
		return [...origin.children];
	},
	"WARRIORS": (list, origin, params) => {
		let targets = [];
		list.children.forEach(c => {
			targets.push(c);
			if (c.children) targets.push(...c.children);
		});

		if (params?.filters) {
			targets = applyFilters(targets, params.filters);
		}

		return targets;
	},
	"LIST": (list) => {
		return [list];
	}
}


export default TLAOK_TARGETS;